interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  showTagline?: boolean;
  withPin?: boolean;
}

const SIZES = {
  // `sm` renders smaller on narrow phones (text-2xl) and grows back to
  // text-3xl from sm: upward, so the in-app top header pill fits 4 action
  // buttons + the wordmark without crowding on iPhone-class widths.
  sm: { word: "text-2xl sm:text-3xl", tag: "text-xs", pin: 28 },
  md: { word: "text-5xl", tag: "text-sm", pin: 40 },
  lg: { word: "text-7xl md:text-8xl", tag: "text-base md:text-lg", pin: 64 },
  xl: { word: "text-8xl md:text-9xl", tag: "text-lg md:text-xl", pin: 80 },
};

/** Pleasant brand mark — cursive wordmark with dotted route + pin motif. */
export const PleasantLogo = ({
  className = "",
  size = "md",
  showTagline = false,
  withPin = true,
}: LogoProps) => {
  const s = SIZES[size];
  return (
    <div className={`inline-flex flex-col items-center ${className}`}>
      {withPin && (
        <svg
          width={s.pin}
          height={s.pin * 1.4}
          viewBox="0 0 64 90"
          fill="none"
          aria-hidden="true"
          className="mb-1"
        >
          {/* Pin */}
          <path
            d="M32 4C18.7 4 8 14.7 8 28c0 18 24 38 24 38s24-20 24-38C56 14.7 45.3 4 32 4z"
            stroke="hsl(var(--mint))"
            strokeWidth="3.5"
            fill="none"
          />
          <circle cx="32" cy="28" r="6" stroke="hsl(var(--mint))" strokeWidth="3.5" fill="none" />
          {/* Dotted trail beneath pin */}
          <g fill="hsl(var(--mint))">
            <circle cx="32" cy="72" r="2" />
            <circle cx="28" cy="78" r="2" />
            <circle cx="22" cy="82" r="2" />
            <circle cx="16" cy="84" r="2" opacity="0.85" />
            <circle cx="22" cy="86" r="2" opacity="0.7" />
            <circle cx="30" cy="86" r="2" opacity="0.55" />
            <circle cx="38" cy="84" r="2" opacity="0.4" />
          </g>
        </svg>
      )}
      <span className={`wordmark leading-none ${s.word}`}>Pleasant</span>
      {showTagline && (
        <span className={`mt-3 text-primary/80 font-sans ${s.tag}`}>intentional navigation</span>
      )}
    </div>
  );
};
